import styled from 'styled-components'
import theme from '../../theme/theme';

export const MainContainer = styled.div`
display: flex;
flex-direction: column;
width: 90%;
margin: 0 auto;
justify-content: center;
// align-items: center;
`;

export const MainHeader = styled.div`
@media (max-width: 400px) {
  margin-left: 20px;
}
`;

export const Title = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 55px;
  margin: 0;
  font-weight: 800;
  padding-top: 50px;
  margin-bottom: 15px;
  color: ${theme.color.navy};
  @media (max-width: 420px) {
    font-size: 40px;
    padding-top: 30px;
  }
`;

export const Container = styled.div` 
    margin: 0 4rem;
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 30px 0 0.7rem 0;
`;

export const UserContainer = styled.div`
display: flex;
width: 100%;
justify-content: space-between;
`;

export const Span = styled.span`
font-size: 1.2rem;
font-weight: bold;
`;

export const Info = styled.p`
font-size: 1.2rem;
`;

export const NullPage = styled.div`
  height: 40vh;
  align-items: center;
  margin-top: 20vh;
  display: flex;
  flex-direction: column;
  @media (max-width: 420px) {
    width: 90%;
  }
`;

export const NullMessage = styled.h1`
  color: ${theme.color.navy};
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0;
  text-align: center;
  @media (max-width: 420px) {
    font-size: 1.7rem;
  }
`;

export const NullDescription = styled.p`
  color: ${theme.color.stone};
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 5px;
  text-align: center;
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  @media (max-width: 420px) {
    flex-direction: column;
    gap: 0px;
  }
`;

export const SearchDiv = styled.div`
  display: flex;
  align-items: center;
  width: 84%;
  @media (max-width: 420px) {
    width: 100%;
  }
`;

export const FilterDiv = styled.div`
  display: flex;
  align-items: center;
  width: 16%;
  justify-content: flex-end;
  @media (max-width: 420px) {
    width: 100%;
  }
`;